import { Tabbar } from "react-vant";
import { useLocation, useNavigate } from "react-router-dom";
import { Bookmark, Flame, Heart, Home, User } from "lucide-react";

const TABS = [
  { path: "/", label: "首页", Icon: Home },
  { path: "/top-deals", label: "好价", Icon: Flame },
  { path: "/brands", label: "品牌", Icon: Bookmark },
  { path: "/favorites", label: "收藏", Icon: Heart },
  { path: "/me", label: "我的", Icon: User },
];

export function ShellWithTabs({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activeIdx = Math.max(
    0,
    TABS.findIndex((t) => t.path === pathname),
  );
  return (
    <div className="app-shell">
      {children}
      <div className="bottom-tabs-wrap">
        <Tabbar
          value={activeIdx}
          onChange={(idx) => {
            const target = TABS[idx as number];
            if (target) navigate(target.path);
          }}
        >
          {TABS.map((t) => (
            <Tabbar.Item key={t.path} icon={<t.Icon size={22} strokeWidth={1.8} />}>
              {t.label}
            </Tabbar.Item>
          ))}
        </Tabbar>
      </div>
    </div>
  );
}
